/**
 * @fileoverview "Appointee of" section for the contact detail panel.
 *
 * Read-only list of the companies on this job that the open contact is the
 * external administration appointee of — directly, or (for a person) via
 * their linked firm. The link itself is managed from the company's panel in
 * `ExternalAdministrationSection`; this just makes it visible from the
 * practitioner's side.
 */

import { Building2 } from "lucide-react";
import type { JobContactRow } from "./types";

interface AppointeeOfSectionProps {
  companies: NonNullable<JobContactRow["administeredCompanies"]>;
}

export function AppointeeOfSection({ companies }: AppointeeOfSectionProps) {
  return (
    <section className="flex flex-col gap-3">
      <h3 className="font-sans text-xs font-semibold uppercase tracking-wider text-foreground">
        Appointee of
      </h3>
      <ul className="flex flex-col gap-1.5">
        {companies.map((company) => (
          <li
            key={company._id}
            className="flex items-center gap-2 rounded-lg border border-border bg-muted/20 p-2.5"
          >
            <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="truncate text-sm font-medium text-foreground">
              {company.displayName}
              {company.externalAdminStatus && (
                <span className="font-normal text-muted-foreground">
                  {" "}
                  ({company.externalAdminStatus})
                </span>
              )}
            </span>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-muted-foreground/80">
        Managed from the company&rsquo;s External administration section.
      </p>
    </section>
  );
}
